import React from 'react'
import { Card, Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt  } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

const IntegrationInfomation = ({className, onDownload, generatedBy, generatedTime}) => {

    return (
        <Card className={className}>
            <Card.Header className="bg-white font-weight-bold text-scb">
                Merchant Integration Information
            </Card.Header>
            <Card.Body className="px-4 pb-5" >
                <Row style={{ padding: "1rem 0" }}>
                    <Col>
                        <Row>
                            <Col className="font-weight-bold">Public Key</Col>
                        </Row>
                        <Row className="mt-3">
                            <Col sm={4} >
                                <Card bg='light'>
                                    <Card.Body>
                                        <Row>
                                            <Col sm={2} className="text-center text-secondary my-auto">
                                                <h2 className="m-0"><FontAwesomeIcon size="lg" icon={faFileAlt}/></h2>
                                            </Col>
                                            <Col className="p-0 mt-1">
                                                <Row>
                                                    <Col className="font-weight-bold text-secondary">
                                                        {generatedBy.trim() === "" ? "System Generated" : "Generated by " + generatedBy}
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className="small text-grey">
                                                        {generatedTime.trim() === "" ? "" : "at " + moment(generatedTime, "YYYYMMDDHHmmss").format("DD-MMM-YYYY HH:mm:ss")}
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col className="my-auto">
                                <Button onClick={onDownload} variant="outline-secondary">Download</Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    )
}

export default IntegrationInfomation
